module.exports = __webpack_public_path__ + "static/media/4-en.3d678c05.jpg";